import React, { useEffect, useRef } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Topbar from '../../../shared/components/Layout/Topbar';
import SettingsSidebar from './SettingsSidebar';
import { useAuthContext } from '../../auth/data/context/AuthContext';
import './SettingsLayout.css';
import '../../../shared/components/Layout/styles/LayoutStyles.css'; // For topbar styles

const SettingsLayout: React.FC = () => {
  const { state, fetchProfile } = useAuthContext();
  const token = state.token || localStorage.getItem('iqadmin_token');
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (token && !state.user && !state.isProfileLoading && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchProfile();
    }
  }, [token, state.user, state.isProfileLoading, fetchProfile]);

  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  if (state.user && state.user.role_name !== 'Super Admin') {
    return <Navigate to="/dashboard" replace />;
  }

  const profile = state.user;
  const userName = (profile as any)?.admin_username || (profile as any)?.full_name || profile?.company_name || 'Institute';
  const userEmail = profile?.email_address || state.email || '';

  return (
    <div className="dashboard-layout">
      <Topbar userName={userName} userEmail={userEmail} />
      <div className="bottom-container">
        <SettingsSidebar />
        <main className="dashboard-content settings-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SettingsLayout;
